<div class="vertical-slider-container">
  <div class="vertical-slider-content">
    <div *ngFor="let card of cards; let i = index"
         class="vertical-slider-card"
         [attr.data-index]="i">
      <div class="vertical-slider-card-text">
        <app-texts [texts]="[
          {text: card.title}
        ]"/>
      </div>
      <div class="vertical-slider-card-img" (click)="openPage(i)">
        <app-menu-card-el [background]="card.img" [style]="card.style ?? ''"/>
      </div>
      <div
        class="vertical-slider-card-portal"
        [class.vertical-slider-card-portal-active]="activeIdx === i && menuIdx != 2 && menuIdx != 4"
        *ngIf="menuIdx != 0 && menuIdx != 2 && menuIdx != 4"
      >
        <app-title-background [locationDto]="locations[i]" style="width: 100%;"/>
      </div>
      <div class="vertical-slider-card-portal" *ngIf="menuIdx === 2"
           [class.vertical-slider-card-portal-active]="activeIdx === i && menuIdx === 2"
      >
        <app-service-el [service]="ServicesArray[i]"/>
      </div>
      <div class="vertical-slider-card-portal" *ngIf="menuIdx === 4"
           [class.vertical-slider-card-portal-active]="activeIdx === i && menuIdx === 4"
      >
        <app-service-el [service]="mockFeedback"/>
      </div>
    </div>
  </div>
</div>
